import Item from './Item';
import InternalUseFieldsList from './InternalUseFieldsList';

const IUF = {
  Edit: InternalUseFieldsList,
  Item,
};

export default IUF;
